import { trackPixel } from './metaPixel'

export const CHECKOUT_URL = 'https://empresagama.com/cart/47409116315797:1'

export function goToCheckout(): void {
  trackPixel('InitiateCheckout', {
    content_name: 'Cero Niebla Mental',
    currency: 'CLP',
    value: 5990,
  })
  window.location.href = CHECKOUT_URL
}
